import { create } from "zustand/react";

interface CoreStore {
  locationId: string | undefined;
  setCurrentLocation: (locationId: string | undefined) => void;
}

export const useCoreStore = create<CoreStore>(set => ({
  locationId: undefined,
  setCurrentLocation: (locationId: string | undefined) => {
    set({ locationId });
  }
}));
